import ScrollWrapper from "../../../Components/ScrollWrapper";
import Text from "../../../Components/Text";
import SmallImage from "../../../Components/SmallImage";
import ChapterToggler from "../../../Components/ChapterToggler";

const CreateWorker = () => {
    return (
        <ScrollWrapper>
            <div className="w-full h-full flex flex-col p-3 gap-4">
                <Text type="maintitle">Mitarbeiter Verwalten</Text>

                <Text type="itemtext">
                    Gib Mitarbeitern mit eigenen Accounts Zugriff auf deinen Workspace
                    und weise ihnen Rollen zu, um ihre Berechtigungen zu steuern.
                </Text>

                <SmallImage src={"instructions/worker-main.png"} />

                {/* Übersicht */}
                <div className="w-full flex flex-col">
                    <Text type="title">1. Neuen Mitarbeiter hinzufügen</Text>
                    <Text type="title">2. Alle Mitarbeiter</Text>
                    <Text type="title">3. Rolle editieren / Löschen</Text>
                </div>

                {/* 1. Neuen Mitarbeiter hinzufügen */}
                <ChapterToggler title="1. Neuen Mitarbeiter hinzufügen">
                    <Text type="itemtext">
                        Durch das Drücken auf diesen Knopf öffnet sich folgendes Formular.
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/worker-create.png"}
                        smallSize="w-1/2"
                        subtitle="Mitarbeiter Formular"
                    />

                    <br />

                    <Text type="itemtext">
                        Folgendes kann definiert werden:
                    </Text>

                    <Text type="itemtext">
                        <b>Email:</b> E-Mail-Adresse eines bereits registrierten Benutzers
                    </Text>

                    <br />

                    <Text type="itemtext">
                        Nach dem Hinzufügen erhält der Benutzer sofort Zugriff auf den Workspace
                        mit der Rolle <b>Mitarbeiter</b>.
                    </Text>
                </ChapterToggler>

                {/* 2. Alle Mitarbeiter */}
                <ChapterToggler title="2. Alle Mitarbeiter">
                    <Text type="itemtext">
                        Auflistung aller Mitarbeiter inklusive ihrer zugewiesenen Rollen.
                    </Text>

                    <br />

                    <Text type="itemtext">
                        Es gibt folgende Rollen:
                    </Text>

                    <Text type="itemtext">
                        <b>Eigentümer:</b> (nicht änderbar) Ersteller des Workspaces mit allen Rechten
                    </Text>

                    <Text type="itemtext">
                        <b>Manager:</b> Alle Rechte außer den direkten Workspace-Einstellungen
                    </Text>

                    <Text type="itemtext">
                        <b>Mitarbeiter:</b> Zugriff auf Kasse und Küchenterminal,
                        keine Rabatte auf Bestellungen möglich
                    </Text>
                </ChapterToggler>

                {/* 3. Rolle editieren / Löschen */}
                <ChapterToggler title="3. Rolle editieren / Löschen">
                    <Text type="itemtext">
                        Diese Knöpfe ermöglichen es, Mitarbeiterrollen zu ändern
                        oder Mitarbeiter vollständig aus dem Workspace zu entfernen.
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/worker-edit.png"}
                        smallSize="w-1/2"
                        subtitle="Rollen Formular"
                    />
                </ChapterToggler>
            </div>
        </ScrollWrapper>
    );
};

export default CreateWorker;
